module.exports = __webpack_public_path__ + "img/txt_info2.37fce73d.png";